import { screenSizes } from './theme';

export const SCROLL_TOP_TO_CONDENSE_HEADER = 265; // The bottom of the CTA on the search page

export const getCtaBottomPosition = () => {
    const callToActionElement = getCta();
    const navbarElement = getNavbar();
    const navbarBottom = navbarElement
        ? navbarElement.getBoundingClientRect().bottom
        : 0;

    if (callToActionElement) {
        const bottomPos = callToActionElement.getBoundingClientRect().bottom;
        const ctaBottomPos = bottomPos - navbarBottom + 36;
        return ctaBottomPos;
    }
    return 0;
};

const getCta = () => {
    return document.getElementsByTagName('md-call-to-action')[0];
};

const getNavbar = () => {
    return document.getElementsByTagName('md-navbar')[0];
};
